import classNames from 'classnames';
import Icon from '../Icon';
import { useCallback, useMemo } from 'react';
import ContentBlockWithPicture from '../ContentBlockWithPicture';
import PropertyPrice from '../PropertyPrice';
import FlexContainer from '../FlexContainer';
import TimeLine from '../TimeLine';
import Txt from '../Txt';
import Picture from '../Picture';
import styles from './PropertyBlock.module.scss';

/**
 * PropertyBlock
 *
 * @return {JSX.Element}
 */
const PropertyBlock = ({
  className,
  bedroomCount = 0,
  bathroomCount = 0,
  postcode,
  deposit,
  tenants,
  name,
  imageUrls = [],
  startDate,
  endDate,
  ...rest
}) => {
  const pictureKeyExtractor = useCallback((url) => url, []);
  const pictureRender = useCallback(
    (url) => <Picture src={url} alt="Property" />,
    []
  );

  const pictures = useMemo(() => imageUrls.filter(Boolean), [imageUrls]);

  return (
    <ContentBlockWithPicture
      className={classNames(
        styles.PropertyBlock,
        className,
        `${PropertyBlock.displayName}`
      )}
      pictures={pictures}
      pictureKeyExtractor={pictureKeyExtractor}
      pictureRender={pictureRender}
      {...rest}
    >
      <FlexContainer column gapQuad>
        {postcode ? (
          <FlexContainer>
            <Txt caption>{postcode}</Txt>
          </FlexContainer>
        ) : null}
        {deposit ? <PropertyPrice value={deposit} /> : null}
        {name ? (
          <FlexContainer>
            <Txt xx>{name}</Txt>
          </FlexContainer>
        ) : null}
        <FlexContainer gapHalf className={styles.IconsBlock}>
          <FlexContainer gapQuad alignCenter>
            <Icon name="bed" />
            <Txt x bold>
              {bedroomCount}
            </Txt>
          </FlexContainer>
          <FlexContainer gapQuad alignCenter>
            <Icon name="bathroom" />
            <Txt x bold>
              {bathroomCount}
            </Txt>
          </FlexContainer>
          {typeof tenants !== 'undefined' ? (
            <FlexContainer gapQuad alignCenter>
              <Icon name="human" />
              <Txt x bold>
                {tenants}
              </Txt>
            </FlexContainer>
          ) : null}
        </FlexContainer>
        {startDate ? (
          <TimeLine
            className={styles.TimeLine}
            dateStart={startDate}
            dateEnd={endDate}
          />
        ) : null}
      </FlexContainer>
    </ContentBlockWithPicture>
  );
};

PropertyBlock.displayName = 'PropertyBlock';

export default PropertyBlock;
